import { style } from 'typestyle';
import { mediaDesktop } from './mediaQueries';
import { percent, px } from 'csx';
import EventBus from './EventBus';

export enum CarouselEvents {
  PAGE_CHANGED = 'pageChanged',
  POSITION_START = 'positionStart',
  POSITION_END = 'positionEnd',
  SCROLL_NEXT = 'scrollNext',
  SCROLL_PREVIOUS = 'scrollPrevious',
}

export type EventCarouselProps = { events: EventBus<CarouselEvents> };

export const defaultCarouselGap = 16;

export const perPageStyles = (gap = defaultCarouselGap) => [
  style({ width: percent(100) }),
  style({ width: `calc(${percent(50)} - (${gap} / 2))` }),
  style({ width: `calc(${percent(33.333333333333336)} - ${(gap * 2) / 3}px)` }),
  style({ width: `calc(${percent(25)} - (${(gap * 3) / 4}px)` }),
  style({ width: `calc(${percent(20)} - ${(gap * 4) / 5}px)` }),
  style({ width: `calc(${percent(16.666666666666668)} - ${(gap * 5) / 6}px)` }),
];

export const desktopOnlyPerPageStyles = (gap = defaultCarouselGap) => [
  style(mediaDesktop({ width: percent(100) })),
  style(mediaDesktop({ width: `calc(${percent(50)} - ${gap / 2}px)` })),
  style(mediaDesktop({ width: `calc(${percent(33.333333333333336)} - ${(gap * 2) / 3}px)` })),
  style(mediaDesktop({ width: `calc(${percent(25)} - ${(gap * 3) / 4}px)` })),
  style(mediaDesktop({ width: `calc(${percent(20)} - ${(gap * 4) / 5}px)` })),
  style(mediaDesktop({ width: `calc(${percent(16.666666666666668)} - ${(gap * 5) / 6}px)` })),
];
